import React from 'react'
import { useGlobalState } from '../../../globalStyle'

const IsSuggestPlanAvailable = ({ showOtherPlan, onRadioChange }) => {
  const isValidCouponCode = useGlobalState("isValidCouponCode")[0];
  if (isValidCouponCode) {
    return;
  }
  return (
    <div className='special-offers'>
      <span className='product-offer-wrapper' onClick={() => onRadioChange()}>
        <span className='product-offer'>Special Offer</span>
        {showOtherPlan ? (
          <span>&#9650;</span> // Up arrow (▲)
        ) : (
          <span>&#9660;</span> // Down arrow (▼)
        )}
      </span>
    </div>
  )
}

export default IsSuggestPlanAvailable